import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./SelectTerm.module.scss";

type Props = {
  termName: string;
  keyword: string;
  handleKeys: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  setKeyword: (value: string) => void;
  setConfirmInput: (value: boolean) => void;
  handleSearch: () => void;
  clearSearch: () => void;
};

const SearchTermInput: React.FC<Props> = ({
  termName,
  keyword,
  handleKeys,
  setKeyword,
  setConfirmInput,
  handleSearch,
  clearSearch,
}) => {
  return (
    <div className={styles["search-area"]}>
      <div className={styles["search-area__input-field"]}>
        <input
          type="text"
          placeholder={`${termName}名で検索`}
          onChange={(e) => {
            setKeyword(e.target.value);
          }}
          value={keyword}
          onKeyDown={handleKeys}
          onCompositionStart={() => {
            setConfirmInput(false);
          }}
          onCompositionEnd={() => {
            setConfirmInput(true);
          }}
        />
        <button
          type="button"
          onClick={clearSearch}
          className={styles["search-area__input-field__clear-btn"]}
        >
          <i>
            <FontAwesomeIcon icon={["fas", "times"]} />
          </i>
        </button>
      </div>
      <button
        type="button"
        onClick={handleSearch}
        className={styles["search-area__search-btn"]}
      >
        <FontAwesomeIcon icon={["fal", "search"]} />
      </button>
    </div>
  );
};

export default SearchTermInput;
